/* eslint-disable import/prefer-default-export */
// Empresa
export const USERAUTH = 1;
